import { Link } from "react-router-dom";
import { ShieldAlert, Home } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { hasPermission } from "../lib/permissions";

/**
 * Route-level permission gate.  Wrap a page with this to require a specific
 * module:read permission.  Superadmin and admin always pass.
 *
 * Renders a friendly "403" screen when the check fails.
 */
export default function PermissionGate({ module, action = "read", children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (hasPermission(user, module, action)) return children;
  return (
    <div
      data-testid="permission-denied"
      className="flex min-h-[70vh] flex-col items-center justify-center text-center px-6"
    >
      <div className="h-16 w-16 rounded-2xl bg-[var(--pop-yellow)]/20 text-[var(--pop-caramel)] flex items-center justify-center mb-4">
        <ShieldAlert size={30} />
      </div>
      <h1 className="font-display text-3xl font-bold mb-2">
        Zugriff verweigert
      </h1>
      <p className="max-w-md text-sm text-[var(--text-muted)] mb-6">
        Dein Konto hat keine Berechtigung für dieses Modul
        <span className="font-mono text-black"> ({module}:{action})</span>.
        Frage den Superadmin nach den passenden Rechten.
      </p>
      <Link
        to="/"
        className="pop-pill bg-[var(--pop-yellow)] text-black font-bold hover:bg-[var(--pop-yellow-dark)]"
        data-testid="btn-back-home"
      >
        <Home size={14} className="mr-1 inline" /> Zurück zum Dashboard
      </Link>
    </div>
  );
}
